import { get } from "@ember/object"

export default function defaultPlanbookDateContext(payload, models) {
  return {
    planbookId: get(models, "planbook.id"),
    planbookTitle: get(models, "planbook.attributes.title"),
    userId: get(models, "user.id"),
    dateString:
      payload.annotation.type === "date-annotation-planbook-custom-single"
        ? payload.annotation.attributes.dateString
        : null,
    startDate:
      payload.annotation.type === "date-annotation-planbook-custom-range"
        ? payload.annotation.attributes.startDate
        : null,
    endDate:
      payload.annotation.type === "date-annotation-planbook-custom-range"
        ? payload.annotation.attributes.endDate
        : null,
    weekdayTitle: get(models, "rotation.attributes.title"),
    calledFrom: get(payload, "calledFrom"),
    title: get(payload, "annotation.attributes.title"),
    isOff: get(payload, "annotation.attributes.isOff"),
    type: (payload.annotation.type === "date-annotation-planbook-custom-single"
      ? "custom-single"
      : payload.annotation.type === "date-annotation-planbook-custom-range"
      ? "custom-range"
      : "default") as "custom-single" | "custom-range" | "default",
  }
}
